const revealedPackIds = new Set<string>();

export const markPackRevealed = (packId: string) => {
  revealedPackIds.add(packId);
};

export const wasPackRevealed = (packId: string) => revealedPackIds.has(packId);
